import {
  HttpContextToken,
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { mergeMap, of, throwError } from 'rxjs';
import { esRespuestaApi, tieneErroresNegocio } from '../utils/api-response.util';

/**
 * Excluye una peticion puntual del normalizador. Uso:
 *   this.http.get(url, { context: new HttpContext().set(OMITIR_NORMALIZADOR_RESPUESTA, true) })
 */
export const OMITIR_NORMALIZADOR_RESPUESTA = new HttpContextToken<boolean>(
  () => false,
);

/**
 * Unico punto donde se desempaqueta el sobre homologado del backend.
 *
 * Los errores de negocio (HTTP 200 con `errors`) se convierten en
 * HttpErrorResponse para que los atienda el flujo central de errores. 
 */
export const apiResponseNormalizerInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.responseType !== 'json' || req.context.get(OMITIR_NORMALIZADOR_RESPUESTA)) {
    return next(req);
  }

  return next(req).pipe(
    mergeMap((event) => {
      if (!(event instanceof HttpResponse) || !esRespuestaApi(event.body)) {
        return of(event);
      }

      const respuesta = event.body;

      if (tieneErroresNegocio(respuesta)) {
        return throwError(
          () =>
            new HttpErrorResponse({
              url: req.urlWithParams,
              status: respuesta.status || event.status || 400,
              statusText: respuesta.message || 'Error de negocio',
              error: respuesta,
            }),
        );
      }

      return of(event.clone({ body: respuesta.data ?? null }));
    }),
  );
};
